<template>
  <div class="form-group">
    <label for="AgeRangeInput"
      >Im Alter von {{ rangeValue[0] }} bis {{ rangeValue[1] }} Jahren</label
    >
    <vue-slider
      ref="vue-slider"
      tooltip="false"
      :min="start"
      :max="end"
      step="1"
      id="AgeRangeInput"
      :value="rangeValue"
      @input="setValue"
      :enableCross="false"
    ></vue-slider>
  </div>
</template>
<script>
export default {
  data() {
    return {
      rangeValue: this.value,
      started: false
    };
  },
  props: {
    value: {
      required: true,
      type: Array
    },
    start: {
      required: false,
      type: Number,
      default: 18
    },
    end: {
      required: false,
      type: Number,
      default: 99
    }
  },
  methods: {
    setValue(event) {
      if (this.$store.getters["user/auth"]) {
        this.rangeValue = event;
      } else {
        this.$refs["vue-slider"].currentValue[0] = this.rangeValue[0];
        this.$refs["vue-slider"].currentValue[1] = this.rangeValue[1];

        // Prevent showing modal on component create
        if (this.started) {
          this.$store.dispatch("publicProfileModal/show", this.$modal);
        } else {
          this.started = true;
        }
      }
    }
  },
  watch: {
    rangeValue() {
      this.$emit("input", [this.rangeValue[0], this.rangeValue[1]]);
    }
  }
};
</script>
